import { jsx as _jsx } from "react/jsx-runtime";
import { Reveal } from "../components/ui/reveal";
import { cn } from "../lib/utils";
import { PAGE_GUTTER, Section } from "./_section";
/**
 * The statement itself, without block chrome — so a component harness renders
 * exactly what a page renders.
 *
 * A `<p>`, and that is load-bearing rather than incidental. A Callout is body
 * copy set apart by the room it is given, not by a place in the page's outline;
 * promoting it to a heading would put a second title on a page that already has
 * one. `compose-callout.spec.ts` asserts the tag, so this cannot drift
 * unnoticed.
 *
 * The prototype's `.landing-statement` / `.vp-lead` treatment is HERE, not
 * pending: display type at `clamp(56px, 8.333cqw, 120px)`, weight 300, `-2.4px`
 * tracking, `text-wrap: balance`, centered in a tall band. Two conversions the
 * port had to make, recorded because every ported block needs them: `cqw` rather
 * than the prototype's `vw`, because `BlockRenderer` wraps every block in
 * `@container` and a viewport unit would ignore the CMS canvas device frames;
 * and Tailwind's `@min-[N]` excludes the boundary while the prototype's
 * `width <= N` includes it, so its 900px breakpoint is `@min-[901px]` here.
 *
 * The shared `Reveal` supplies the entrance animation. Viewport-relative
 * parallax belongs in `packages/web` (see `ChapterScrollEffects`), not
 * in a block that also has to render inside a CMS device frame.
 */
export function CalloutView({ data }) {
    return (_jsx(Reveal, { asChild: true, children: _jsx("p", { "data-callout-text": true, className: cn("max-w-[1054px] text-balance font-display text-brand-blue font-light leading-none", "text-[clamp(48px,15cqw,68px)] tracking-[-1.2px]", "@min-[901px]:text-[clamp(56px,8.333cqw,120px)] @min-[901px]:tracking-[-2.4px]"), children: data.text }) }));
}
export function CalloutBlock({ data }) {
    return (_jsx(Section, { tone: "default", className: cn("flex items-center justify-center text-center", PAGE_GUTTER), children: _jsx(CalloutView, { data: data }) }));
}
export function calloutFromBlock(block, _resolve) {
    const scalars = block.scalars ?? {};
    return { text: scalars.text ?? "" };
}
export const calloutBlockEntry = {
    Component: CalloutBlock,
    fromBlock: calloutFromBlock,
};
//# sourceMappingURL=callout.js.map